import Home from './home'
import Record from './record'
export default {
  Home,
  Record,
}
